import React, {useContext, useEffect, useState} from 'react';

import {makeStyles} from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import {useHistory} from "react-router-dom";
import {PermissionsContext, ErrorContext} from "../utils/constants";
import Colors from "../utils/colors";
import {getData} from "../utils/apiUtils";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import apiFetch from "../utils/apiUtils";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles(() => ({
  h1: {
    fontWeight: 500,
    fontSize: '56px',
    lineHeight: '66px',
  },
  addContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  addArea: {
    width: '45%',
    backgroundColor: Colors.lightBlue,
    padding: '1rem'
  },
  inputStyle: {
    marginTop: '1rem',
    marginBottom: '1rem',
    backgroundColor: 'white'
  },
  tableStyle: {
    border: '1px solid black',
    padding: '1rem'
  },
  table: {
    border: '1px solid black',
    width: '100%',
    marginTop: '3rem'
  },
  chip: {
    margin: '0.5rem'
  }
}));
// NOTE: This page is used for both the see all and administrator dashboards
export default function AdminSeeAllUserDashboard({title, subtitle, url}) {
  const classes = useStyles();
  const history = useHistory();
  const { isAdmin } = useContext(PermissionsContext);
  const { triggerError } = useContext(ErrorContext);

    if (!isAdmin) {
      history.push('/ui/errors/error404');
    }

  const [usersList, setUsersList] = useState([]);
  const [ userAutocompleteList, setUserAutocompleteList ] = useState([]);
  const [ selectedUser, setSelectedUser ] = useState({displayName: ''});

  useEffect(() => {
    const onError = () => triggerError({
      title: 'Communication Error',
      description: 'We were unable to read your user data from the server. Please try again.',
      onRetry: () => window.location.reload(),
    });
    setUsersList([]);
    setSelectedUser({displayName: ''});
    setUserAutocompleteList([]);

    getData(url, setUsersList, onError);
    document.title = `Rise by TransAlta Admin ${title} Dashboard`;
  }, [triggerError, url]);

  const onAutocompleteError = (error) => {
    // deliberately left blank.  We don't want a popup with every letter typed.
    console.log(error);
  };

  const handleUserAutocompleteChange = (event) => {
    const value = event.target.value;
    if (value.length >=2) {
      getData('/users/' + value, setUserAutocompleteList, onAutocompleteError);
    }
  };

  const handleUserSelect = (event, selectedValue) => {
    if (!selectedValue) {
      return;
    }
    setSelectedUser(selectedValue);
  };

  const handleUserAdd = () => {
    const data = selectedUser;
    apiFetch(url, 'POST',
      JSON.stringify(data),
      (results) => {
        setUsersList(results);
      }, (selectedUser) => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to save user ${selectedUser.displayName}. Please try again.`,
        onRetry: () => handleUserAdd(),
      }));
  }

  const handleDelete = (id) => () => {
    apiFetch(url + id, 'DELETE',
      null,
      (results) => {
        setUsersList(results);
      }, () => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to delete the selected card. Please try again.`,
        onRetry: () => handleDelete(id),
      }));
  };

  const getUserChip = (user) => {
    return  <Chip label={user.name}
                  size="small"
                  onDelete={handleDelete(user.id)}
                  color="primary"
                  key={user.id + '-tag'}
                  className={classes.chip}
    />;
  };

  const getUserRow = (type) => {
    return (
      <tr key={`row-user-chips`}>
      <td className={classes.tableStyle}>
        {usersList.map(user => getUserChip(user))}
      </td>
      </tr>
    );
  };

  return (
    <main>
      <h1 className={classes.h1}>{title}</h1>
      <h2 className={classes.h1}>{subtitle}</h2>
      <div className={classes.addContainer} >
        <div className={classes.addArea}>
          <h2>Add User</h2>
          <Autocomplete
            id={'combo-box-user-1'}
            options={userAutocompleteList}
            getOptionLabel={option => option? option.displayName : ''}
            style={{ width: '100%' }}
            value={selectedUser}
            size="small"
            onChange={handleUserSelect}
            renderInput={params => (
              <TextField {...params}
                         variant="outlined"
                         fullWidth
                         className={classes.inputStyle}
                         onChange={handleUserAutocompleteChange}
                         placeholder="User Name..."
              />
            )}
          />
          <div className={classes.addContainer} >
            <Button
              className={classes.btnStyle}
              variant="contained"
              onClick={handleUserAdd}
            >
              ADD
            </Button>
          </div>
        </div>

      </div>

      <div>
        <table className={classes.table}>
          <thead>
          <tr>
            <th className={classes.tableStyle} key="table-header-type">users</th>
          </tr>
          </thead>
          <tbody>
          {getUserRow()}
          </tbody>
        </table>
      </div>

    </main>
  );
}
